export default __webpack_public_path__ + "static/media/GenesisAttractLoop2023.a1d4850c.mp4";